import Constants from '@/Constants';
import { ProgramListStudentViewRequest } from '@/models/ProgramListStudentViewRequest';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { updateContentStudentViewRequest } from '../item/action';
import { updateCourseStudentViewRequest } from '../list/action';
import { updateProgramClassStudentViewRequest } from '../program/action';
import {
    getRateFailure,
    getRateSuccess,
    setContentRateFailure,
    setContentRateSuccess,
    setCourseRateFailure,
    setCourseRateSuccess,
    setProgramRateFailure,
    setProgramRateSuccess,
} from './actions';
import { RateData, RatingTypes } from './types';

export function* getRateRequest(action: PayloadAction<RatingTypes.GET_RATE_REQUEST, { uri: string; entityId: number; personId: number }>) {
    try {
        const { uri, personId, entityId } = action.payload;

        const { data } = yield call(http.get, uri.replace('%p', personId.toString()).replace('%c', entityId.toString()));
        yield put(getRateSuccess(data.ratings[0]));
    } catch (error) {
        yield put(getRateFailure(error));
    }
}

export function* rateStudentCourseRequest(action: PayloadAction<RatingTypes.SET_COURSE_RATE_REQUEST, RateData>) {
    try {
        const { personId, entityId, classEnrollmentId } = action.payload;
        yield call(http.post, Constants.SOCIAL_COURSE_RATING_URI.replace('%s', entityId.toString()), action.payload);
        yield put(setCourseRateSuccess(action.payload));
        yield put(updateCourseStudentViewRequest({ personId, courseId: entityId, classEnrollmentId }));
    } catch (error) {
        yield put(setCourseRateFailure());
    }
}

export function* rateStudentContentRequest(action: PayloadAction<RatingTypes.SET_CONTENT_RATE_REQUEST, RateData>) {
    try {
        const { personId, entityId } = action.payload;
        yield call(http.post, Constants.SOCIAL_CONTENT_RATING_URI.replace('%s', entityId.toString()), action.payload);
        yield put(setContentRateSuccess(action.payload));
        yield put(updateContentStudentViewRequest({ personId, contentId: entityId }));
    } catch (error) {
        yield put(setContentRateFailure(action.payload));
    }
}

export function* rateStudentProgramRequest(action: PayloadAction<RatingTypes.SET_PROGRAM_RATE_REQUEST, RateData>) {
    try {
        const { personId, entityId, classEnrollmentId } = action.payload;
        yield call(http.post, Constants.SOCIAL_PROGRAM_RATING_URI.replace('%s', entityId.toString()), action.payload);
        yield put(setProgramRateSuccess(action.payload));
        yield put(
            updateProgramClassStudentViewRequest({
                personId,
                classEnrollmentId,
                programId: entityId,
            } as ProgramListStudentViewRequest),
        );
    } catch (error) {
        yield put(setProgramRateFailure(action.payload));
    }
}
